import { Story, Meta } from '@storybook/web-components';
import { html } from 'lit-html';
import '../remark-element';
import './app-bar';
import '../logo';
import '../form/button';

// More on default export: https://storybook.js.org/docs/web-components/writing-stories/introduction#default-export
export default {
  title: '@gsmlg/app-bar',
  // More on argTypes: https://storybook.js.org/docs/web-components/api/argtypes
  argTypes: {},
} as Meta;

export interface ElementProps {
  appName: string;
  fixed: boolean;
  hidename: boolean;
  color: string;
  backgroundColor: string;
}

// More on component templates: https://storybook.js.org/docs/web-components/writing-stories/introduction#using-args
const Template: Story<ElementProps> = ({
  appName,
  fixed,
  color,
  backgroundColor,
  hidename,
}) =>
  html`
    <app-bar
      app-name=${appName}
      ?fixed=${fixed}
      ?hidename=${hidename}
      color=${color}
      background-color=${backgroundColor}
    >
      <logo-gsmlg-dev slot="logo"></logo-gsmlg-dev>
      <wc-button slot="nav" mode="primary">Console</wc-button>
      <wc-button slot="nav" mode="link">Dashboard</wc-button>
      <div slot="user">Josh</div>
      <div slot="actions">M</div>
    </app-bar>

    <remark-element>
      ## app-bar element Render AppBar for application. \`\`\`html ${`<app-bar
      app-name=${appName}
      ?fixed=${fixed}
      ?hidename=${hidename}
      color=${color}
      background-color=${backgroundColor}
    >
      <logo-gsmlg-dev slot="logo"></logo-gsmlg-dev>
      <wc-button slot="nav" mode="primary">Console</wc-button>
      <wc-button slot="nav" mode="link">Dashboard</wc-button>
      <div slot="user">Josh</div>
      <div slot="actions">M</div>
    </app-bar>`} \`\`\` ### CSS Variables \`\`\`css var(--app-bar-background-color,
      #fc125c); var(--app-bar-color, #fff); var(--app-bar-height, 3.5rem);
      var(--app-bar-menu-background-color, inherit); var(--app-bar-menu-color, inherit);
      var(--app-bar-menu-item-background-color, inherit); var(--app-bar-menu-item-color,
      inherit); var(--app-bar-name-color, inherit); \`\`\` ### attributes: - \`app-name\`
      show when screen width > 992px \`GSMLG-DEV\` is app-name in demo - \`fixed\` set
      app-bar to \`postion: fixed\`, need to add a padding-top to page - \`hidename\`
      force hide app-name - \`color\` text color - \`background-color\` background color
      ### slots: - \`logo\` Where logo is placed. - \`nav\` Add nav menus. - \`actions\`
      Add user actions, right part, user slot's left. - \`user\` Add user Icon or menu, at
      right part.
    </remark-element>
  `;

export const Basic = Template.bind({});
// More on args: https://storybook.js.org/docs/web-components/writing-stories/args
Basic.args = {
  appName: 'GSMLG-DEV',
  fixed: false,
  hidename: false,
  color: '#fff',
  backgroundColor: '#000',
};
